import { EFormColumn } from './e-form-column.model';
import { EFormControl } from './e-form-control.model';

export class EFormRow {
    Id: number;
    Height = 75;
    Order: number;
    Columns: EFormColumn[] = [];
    Controls: EFormControl[] = [];
    Alignment = 'flex-start';

    // Tree View Property
    Expanded: boolean;
}